import React, { useRef } from "react";
import { CommunityTitle } from "../../../components/community/community-title";
import { Link } from "react-router-dom";
import { PostCard } from "./components/post-card";
import { useBlogPosts } from "../../hooks/use-blog-post";
import { Icon } from "@iconify/react";
import { useTranslations } from "../../../hooks/use-translations";
import _ from "lodash";
import useIsMobile from "../../../js/utilities/useIsMobile";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Mousewheel, Navigation } from "swiper";
import { useLanguage } from "../../../hooks/use-language";

export const Blog = React.forwardRef((props, ref) => {
	const lang = useLanguage();
	const texts = useTranslations({ section: "comunidad_club", lang: lang });
	const posts = useBlogPosts();
	const recentPosts = posts.data;
	const loading = posts.loading;

	const isMobile = useIsMobile();
	const prevButtonRef = useRef(null);
	const nextButtonRef = useRef(null);

	const updateNavigation = (swiper) => {
		swiper.params.navigation.prevEl = prevButtonRef?.current
		swiper.params.navigation.nextEl = nextButtonRef?.current
		swiper.navigation.destroy()
		swiper.navigation.init()
		swiper.navigation.update()
	}

	return (
		<div className="blog-section w-100 my-5">
			<div className="container mb-5">
				<div ref={ref} style={{ scrollMarginTop: 60 }}>
					<CommunityTitle.H4 title={_.get(texts, 'blog.titulo') || `Blog`} />
				</div>
				<div className="d-flex d-lg-none justify-content-end mt-3 mt-lg-0">
					<button ref={prevButtonRef} aria-label="previous" className="home-swiper-navigation-buttons mx-2">
						<Icon className="icon" icon="material-symbols:arrow-back-rounded" width={20} />
					</button>
					<button ref={nextButtonRef} aria-label="next" className="home-swiper-navigation-buttons">
						<Icon className="icon" icon="material-symbols:arrow-forward-rounded" width={20} />
					</button>
				</div>
			</div>
			<div className="container">
				{loading ? (
					<div className="w-100 h-100 d-flex justify-content-center align-items-center secondary-inverse--color">
						<Icon
							icon="icomoon-free:spinner9"
							width={60}
							className={"spinner-rotation"}
						/>
					</div>
				) : (

					isMobile ?
						<Swiper
							className=""
							style={{ overflowX: 'hidden' }}
							slidesPerGroup={1}
							slidesPerView={1}
							spaceBetween={40}
							breakpoints={{
								670: {
									slidesPerView: 2,
									slidesPerGroup: 2,
								}
							}}
							autoplay={{
								delay: 5000,
								disableOnInteraction: false,
							}}
							mousewheel={{
								forceToAxis: true,
							}}
							navigation={{
								nextEl: nextButtonRef?.current,
								prevEl: prevButtonRef?.current,
							}}
							onSwiper={(swiper) => {
								updateNavigation(swiper);
							}}
							modules={[Autoplay, Navigation, Mousewheel]}
						>
							{recentPosts?.map((post, i) => {
								return (
									<SwiperSlide
										className=" d-flex justify-content-center align-items-center"
										key={`postRes-${post?.idBlog}-${i}`}
									>
										<PostCard
											key={`post-${post?.idBlog}-${i}`}
											data={{
												...post,
												cover: post?.portada,
												date: post?.fecha,
												id: post?.idBlog,
											}}
										/>
									</SwiperSlide>
								);
							})}
						</Swiper>
						:
						<div className="d-flex justify-content-center align-items-center">
							<ul className="row w-100 p-0 m-0 justify-content-between">
								{recentPosts?.map((post, i) => {
									return (
										<li
											className="col-12 col-md-6 col-lg my-3 d-flex justify-content-center align-items-center"
											key={`post-${post?.idBlog}-${i}`}
										>
											<PostCard
												key={`post-${post?.idBlog}-${i}`}
												data={{
													...post,
													cover: post?.portada,
													date: post?.fecha,
													id: post?.idBlog,
												}}
											/>
										</li>
									);
								})}
							</ul>
						</div>
				)}
			</div>

			<div className="container  my-5 d-flex justify-content-center align-items-center">
				<Link
					className="focusable-red btn btn-primary p-2 px-3"
					to={"/blog"}
				>{_.get(texts, 'blog.boton.explorar_blog') ||  `Explora nuestro Blog`}</Link>
			</div>
		</div>
	);
});
